import { toast } from 'react-toastify';
import moment from 'moment';

import {
  fetchServicesScheduling,
  createServicesScheduling,
  updateServicesScheduling,
  updateServicesSchedulingConfirmation,
  deleteServicesScheduling,
  fetchServicesExecutionTime
} from './services';

import {
  setIsLoading,
  setSchedulingServices
} from './actions';

import { loadCalendarServices } from 'pages/Scheduling/store/thunk';

export const loadServicesScheduling = (userId, establishmentId, id) => dispatch => {
  dispatch(setIsLoading(true));

  return fetchServicesScheduling(userId, establishmentId, id)
    .then(({ data }) => dispatch(setSchedulingServices(data)))
    .finally(() => dispatch(setIsLoading(false)));
}

export const upsertServicesScheduling = (userId, establishmentId, id, params) => dispatch => {
  dispatch(setIsLoading(true));

  if(!id) {
    return createServicesScheduling(userId, establishmentId, params)
      .then(() => {
        toast.success('Agendamento cadastrado com sucesso.');
        return Promise.resolve();
      })
      .catch(error => {
        if(error?.hasOwnProperty('vehicle.vehicleColor')) {
          toast.error(error['vehicle.vehicleColor'][0]);
          return Promise.reject();
        }

        if(error?.hasOwnProperty('vehicle.vehicleModel')) {
          toast.error(error['vehicle.vehicleModel'][0]);
          return Promise.reject();
        }

        if(+error?.response?.data?.data?.code == 400) {
          return Promise.reject();
        }

        toast.error('Houve um problema ao cadastrar o agendamento.');
        return Promise.reject();
      })
      .finally(() => dispatch(setIsLoading(false)));
  }

  return updateServicesScheduling(userId, establishmentId, id, params)
    .then(() => {
      toast.success('Agendamento atualizado com sucesso.');
      return Promise.resolve();
    })
    .catch(error => {
      if(error?.hasOwnProperty('vehicle.vehicleColor')) {
        toast.error(error['vehicle.vehicleColor'][0]);
        return Promise.reject();
      }

      if(error?.hasOwnProperty('vehicle.vehicleModel')) {
        toast.error(error['vehicle.vehicleModel'][0]);
        return Promise.reject();
      }

      if(+error?.response?.data?.data?.code == 400) {
        return Promise.reject();
      }

      toast.error('Houve um problema ao atualizar o agendamento.');
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const setUpdateServicesSchedulingConfirmation = (userId, establishmentId, id) => dispatch => {
  dispatch(setIsLoading(true));

  return updateServicesSchedulingConfirmation(userId, establishmentId, id)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const removeServicesScheduling = (userId, establishmentId, id, params) => dispatch => {
  dispatch(setIsLoading(true));

  return deleteServicesScheduling(userId, establishmentId, id, params)
    .then(() => {
      toast.success('Agendamento removido com sucesso.');

      const extraProps = {
        initialDate: moment().startOf('month').format('YYYY-MM-DD'),
        finalDate: moment().endOf('month').format('YYYY-MM-DD')
      }

      dispatch(loadCalendarServices(userId, establishmentId, extraProps, ''));

      return Promise.resolve();
    })
    .catch(() => {
      toast.error('Houve um problema ao remover o agendamento.');
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const loadServicesExecutionTime = (userId, establishmentId, params) => dispatch => {
  return fetchServicesExecutionTime(userId, establishmentId, params)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch(() => {
      return Promise.reject();
    });
}